<template>
  <div class="flex flex-col items-center justify-center px-6 pt-24 text-center">
    <div class="text-[16px] font-medium leading-[20px] text-gray-800">
      No results found
    </div>
    <div class="mt-1.5 text-[14px] leading-[20px] text-gray-500">
      Try different keywords
    </div>
  </div>
</template>
